import React from "react";
import { Link } from "react-router-dom";
import "./ConstNeed.css";

import { FiArrowUpRight } from "react-icons/fi";
import { solutionsDetailList } from "../../../../data/solutionsDetailData";

const ConstNeed = () => {
  return (
    <section className="constNeed">
      <div className="constNeed-inner">
        <div className="constNeed-header">
          <span className="constNeed-tag">OUR SOLUTIONS</span>

          <h2 className="constNeed-title">
            Integrated Systems
            <br />
            for Every{" "}
            <span className="constNeed-titleAccent">Construction Need</span>
          </h2>

          <p className="constNeed-intro">
            IRQGYP delivers integrated solutions across every stage of
            construction, the complete solution from foundations to final
            finishes.
          </p>
        </div>

        <div className="constNeed-cards">
          {solutionsDetailList.map((item) => (
            <Link
              className="constNeed-card"
              key={item.slug}
              to={`/solutiondetails/${item.slug}`}
            >
              <div className="constNeed-cardTop">
                <div className="constNeed-cardIcon">
                  <img src={item.cardIcon} alt="" draggable={false} />
                </div>
              </div>

              <div className="constNeed-cardBottom">
                <h3>{item.title}</h3>

                <p>{item.cardDescription}</p>

                <div className="constNeed-more">
                  More Details <FiArrowUpRight />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConstNeed;
